export default __webpack_public_path__ + "static/media/Tatacara.60adb56f.png";